<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import BrowserPreview from "@/views/dataAnalysis/components/BrowserPreview.vue";
import { handleAlert } from "@/components/UtilsIf";
import { useThrottle } from "@/utils/useThrottle";
import { create_record } from "@/api/dataAnalysis";

export default {
  name: "dataAnalysis",
  components: { BrowserPreview, breadcrumbs },
  provide() {
    return { form: this.form };
  },
  data() {
    const throttle = useThrottle({
      duration: 0.05, // 2.5分钟
      cacheKey: "submit_order_btn",
      enableCache: true
    });
    return {
      throttle,
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.orderStartDate;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },

      form: {
        orderStartDate: null,
        orderEndDate: null,
        equipmentIds: null,
        regionIds: null
      },
      companyId: null,
      show: false,
      payInfo: {}
    };
  },
  created() {
    this.companyId = this.$store.getters.get_token.companyId;
  },
  watch: {
    "form.orderStartDate"() {
      if (this.form.orderStartDate == null) {
        this.form.orderEndDate = null;
      }
    }
  },
  methods: {
    search() {
      this.$api.dataAnalysis
        .create_record({
          companyId: this.companyId,
          ...this.form
        })
        .then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.payInfo = res.data;
              this.$refs.QRModal.open("支付");
            }
          }
        });
    },
    reset() {
      this.form.orderStartDate = null;
      this.form.equipmentIds = null;
      this.form.orderEndDate = null;
      this.form.regionIds = null;
    },
    toRecord(record) {
      this.$router.push({ path: `/dataAnalysis/dataAnalysisRecord` });
    },
    handleSubmitClick() {
      return this.throttle.handleClick(this.search);
    },

    openModal() {
      this.$refs.formModal.open("选择设备");
    }
  }
};
</script>

<template>
  <div class="container">
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <div class="pdt-15 pdb-0 bg-white">
      <el-form ref="form" :model="form" label-width="120px" inline>
        <el-form-item label="设备编号">
          <div class="custom_input" @click="openModal()">
            请选择设备编号
          </div>
        </el-form-item>
        <el-form-item label="数据时间范围">
          <el-date-picker
            v-model="form.orderStartDate"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.orderEndDate"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            :disabled="throttle.isCooling()"
            @click="handleSubmitClick"
          >
            <template v-if="throttle.isCooling()">
              预计{{ throttle.remainingSeconds() }}s
            </template>
            <template v-else>
              分析
            </template>
          </el-button>
          <el-button @click="reset">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="pdt-15 pdb-15 flex flex-end">
      <el-button type="primary" icon="el-icon-document" @click="toRecord"
        >分析记录</el-button
      >
    </div>
    <div class="container__ai bg-white" style="min-height: 500px">
      <div
        class="left"
        :style="{
          width: show ? '100%' : '160px'
        }"
      >
        <div class="fold" v-if="!show">
          <div class="title mg-15">使用说明</div>
          <el-tooltip
            class="item"
            effect="dark"
            content="点击查看使用说明"
            placement="top"
          >
            <div class="icon" @click="show = !show">
              <i class="el-icon-s-fold" />
            </div>
          </el-tooltip>
        </div>
        <div class="expand mg-15" v-show="show">
          <div></div>
          <el-tooltip
            class="item"
            effect="dark"
            content="关闭使用说明"
            placement="top"
          >
            <div class="icon" @click="show = !show">
              <i class="el-icon-s-unfold" />
            </div>
          </el-tooltip>

          <div class="pdt-10">
            <div class="color0063ea fw-600 mgb-5 mgt-15">第一步:筛选条件</div>
            <div>在页面顶部筛选您所需要的条件进行针对性数据分析。</div>
            <div class="color0063ea mgr-20 fw-600 mgb-5 mgt-15">
              第二步:付费分析
            </div>
            <div>点击分析按钮，进行单次付费分析。</div>
            <div class="color0063ea mgr-20 fw-600 mgb-5 mgt-15">
              第三步:生成分析报告
            </div>
            <div>
              付费成功后，将根据您企业的真实数据，生成专属于您企业的数据报告，为您的经营策略提供最合适的决策建议。
            </div>
          </div>
          <BrowserPreview
            class="mgt-15"
            src="https://pip.mr-future.com/ai/analysis_result.html"
          />
        </div>
      </div>
      <div class="right" v-if="!show">
        <div class="header">你好，尊敬的企业用户!</div>
        <div class="des">
          请选择您的筛选条件，生成专属于您企业数据的针对性分析报告
        </div>
      </div>
    </div>
    <customModal
      ref="formModal"
      path="views/dataAnalysis/components/formModal"
      center
      :footer="true"
      width="1000px"
    >
    </customModal>
    <customModal ref="QRModal" :footer="false" center width="500px">
      <div style="display: flex; align-items: center; justify-content: center;">
        <el-image
          style="width: 150px; height: 150px;"
          :src="payInfo.img"
          fit="fill"
        ></el-image>
      </div>
    </customModal>
  </div>
</template>

<style scoped lang="scss">
.container {
  .custom_input {
    -webkit-appearance: none;
    background: var(--card-bg);
    background-image: none;
    border-radius: 4px;
    border: 1px solid var(--input-border);
    box-sizing: border-box;
    color: var(--text-muted);
    display: inline-block;
    font-size: inherit;
    outline: none;
    padding: 0 15px;
    height: 28px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    font-size: 12px;
    cursor: pointer;
  }
  &__ai {
    display: flex;
    .left {
      transition: all ease-in-out 0.3s;
      background: var(--card-bg);
      border-right-color: #060a2608;
      border-right-width: 1px;
      .fold {
        display: flex;
        align-items: center;
        .icon {
          margin-right: 15px;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          background-color: transparent;
          transition: background-color 0.2s;
          cursor: pointer;
          &:hover {
            background-color: #2631480f;
          }
        }
      }
      .expand {
        display: flex;
        flex-direction: column;
        .icon {
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          background-color: #2631480f;
          transition: background-color 0.2s;
          cursor: pointer;
        }
      }
    }
    .right {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      @keyframes typing {
        0% {
          width: 0;
        }
        100% {
          width: 26ch;
        }
      }
      .header {
        font-size: 28px;
        font-family: "Avenir", Helvetica, Arial, sans-serif;
        font-weight: 700;
        width: 26ch;
        white-space: nowrap;
        overflow: hidden;
        text-align: center;
        animation: typing 2s steps(26, end);
      }
      .des {
        margin-top: 20px;
        color: var(--text-muted);
      }
    }
  }
  .title {
    color: var(--accent);
    font-weight: 400;
  }
}
</style>
